import Guard from '@/services/middleware'

const DashLayout = () => import('@/layouts/DashLayout')
const HomeTemplates = () => import('@/views/dash/messages/templates/HomeTemplates')
const HomeModels = () => import('@/views/dash/messages/templates/HomeModels')
const CreateTemplates = () => import('@/views/dash/messages/templates/CreateTemplates')

export default [
    {
        path: '/mensagens/templates',
        component: DashLayout,
        beforeEnter: [Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess],
        children: [
            { path: '', name: 'messages.templates.home', component: HomeTemplates, meta: { title: 'Lista de templates', permission: 2, module: 'messages_template' } },
            { path: 'modelos', name: 'messages.templates.models', component: HomeModels, meta: { title: 'Modelos de Templates', permission: 2, module: 'messages_template' } },
            { path: ':id', name: 'messages.templates.manager', component: CreateTemplates, meta: { title: 'Gerenciar template', permission: 2, module: 'messages_template' } },
            { path: 'cadastrar', name: 'messages.templates.create', component: CreateTemplates, meta: { title: 'Cadastrar template', permission: 2, module: 'messages_template' } },
        ],
    },
]